import { EbayPresenter } from 'components/domain/ebay/EbayPresenter'
import { AppLayout } from 'components/facets'
import { useUser } from 'components/providers/UserProvider'
import { Redirect } from 'react-router-dom'

export const Ebay = (): JSX.Element => {
  const { user } = useUser()

  if (!user || user?.subscription.allFeaturesDisabled || !user.isAdmin) {
    return <Redirect to="/" />
  }

  return (
    <AppLayout noDOMLayout>
      <EbayPresenter />
    </AppLayout>
  )
}
